import base from '~base';
import scrollTo from '../util/scrollTo';
import clientSideValidation from './clientSideValidation';

const ELEMENT_CLASS = {
  ERROR_CONTAINER: 'fields-error-container',
};
const SELECTORS = {
  ERROR_CONTAINER: `.${ELEMENT_CLASS.ERROR_CONTAINER}`,
  RECAPTCHA_ELEMENT: '.g-recaptcha-key',
};

const googleRecaptcha = () => {
  const placeholder = document.querySelector(SELECTORS.RECAPTCHA_ELEMENT);
  // eslint-disable-next-line jquery/no-val
  const form = placeholder.closest('form');
  if (form) {
    form.querySelector('.g-recaptcha-response').value = '';
    const { sitekey } = placeholder.dataset;
    // eslint-disable-next-line no-undef
    grecaptcha.ready(() => {
      // eslint-disable-next-line no-undef
      grecaptcha.execute(sitekey, { action: 'submit_captcha' }).then((token) => {
        form.querySelector('.g-recaptcha-response').value = token;
      });
    });
  }
};

function assignMessageComponent(formElement, payload) {
  base.call(this, formElement, payload);
  // eslint-disable-next-line prefer-destructuring
  const action = payload.action;

  if (action === 'Account-Login' || action === 'Account-SubmitRegistration' || action === 'Newsletter-Handler') {
    // Reinit Recaptcha after validation
    googleRecaptcha();
  }

  if (payload && (payload.errorSummaryTemplate || payload.error.length > 0)) {
    // in case the marker is inside the form field error container
    const form = formElement[0].tagName === 'FORM' ? formElement[0] : formElement[0].parentNode;

    // remove SFRA error container if there is one
    const containerToRemove = form.querySelector('.alert.alert-danger');
    if (containerToRemove && payload.errorSummaryTemplate) {
      form.removeChild(containerToRemove);
    }

    let container = document.querySelector(form.dataset.errorContainer || SELECTORS.ERROR_CONTAINER);
    if (container) {
      // clean the container data and reuse it
      container.innerHTML = '';
    } else {
      // creates new error container
      container = document.createElement('div');
      container.classList.add(ELEMENT_CLASS.ERROR_CONTAINER);
      form.parentNode.insertBefore(container, form);
    }
    // insert the error summary content in the error container
    if (payload.errorSummaryTemplate) {
      container.innerHTML = payload.errorSummaryTemplate;
    }

    if (payload.action === 'Account-Login') {
      if (payload.error.length > 0) {
        clientSideValidation.functions.loginValidation(formElement[0], ' ');
      }
    }

    setTimeout(() => {
      scrollTo(container);
    }, 100);
  } else if (payload && payload.fields) {
    const firstErrorFieldName = Object.keys(payload.fields)[0];
    const firstErrorField = document.querySelector(`[name="${firstErrorFieldName}"]`);

    if (firstErrorField) {
      scrollTo(firstErrorField);
      firstErrorField.focus();
    }
  }
}

export default assignMessageComponent;
